import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AppleLogo } from './AppleLogo.js';
import { DiscordLogo } from './DiscordLogo.js';
import { FacebookLogo } from './FacebookLogo.js';
import { GitHubLogo } from './GitHubLogo.js';
import { GitLabLogo } from './GitLabLogo.js';
import { GoogleLogo } from './GoogleLogo.js';
import { LinkedInLogo } from './LinkedInLogo.js';
import { MicrosoftLogo } from './MicrosoftLogo.js';
import { TwitterLogo } from './TwitterLogo.js';
/**
 * Dispatcher: renders the canonical logo for a given provider id.
 *
 * Use this in OAuth button rows so the button chrome (padding, radius,
 * width, background) stays per-app while the logo itself is identical
 * across every consumer.
 *
 * @param props - Component props (see {@link OAuthProviderLogoProps}).
 * @example
 * ```tsx
 * <OAuthProviderLogo provider="github" size={20} mode="mono" />
 * <OAuthProviderLogo provider="google" size={24} />
 * ```
 */
export function OAuthProviderLogo({ provider, fallback = null, ...rest }) {
    switch (provider) {
        case 'github':
            return _jsx(GitHubLogo, { ...rest });
        case 'gitlab':
            return _jsx(GitLabLogo, { ...rest });
        case 'google':
            return _jsx(GoogleLogo, { ...rest });
        case 'twitter':
        case 'x':
            return _jsx(TwitterLogo, { ...rest });
        case 'apple':
            return _jsx(AppleLogo, { ...rest });
        case 'facebook':
            return _jsx(FacebookLogo, { ...rest });
        case 'microsoft':
            return _jsx(MicrosoftLogo, { ...rest });
        case 'linkedin':
            return _jsx(LinkedInLogo, { ...rest });
        case 'discord':
            return _jsx(DiscordLogo, { ...rest });
        default:
            return _jsx(_Fragment, { children: fallback });
    }
}
